import { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

import {
    ErrorIcon,
    InfoNotificationIcon,
    SuccessIcon,
    WarningIcon,
} from "../../assets/icons";
import { NotificationLevel } from "./types";

interface NotificationIconProps {
    level: NotificationLevel;
    size: "inherit" | "default" | "small" | "large";
    className?: string;
    customIcon?: React.ReactElement<SvgIconProps>;
}

export const NotificationIcon = (props: NotificationIconProps) => {
    const renderCustomIcon = () => {
        if (!props.customIcon) return null;

        return React.cloneElement(
            props.customIcon as React.ReactElement<SvgIconProps>,
            {
                fontSize: props.size,
                className: props.className,
            }
        );
    };

    const getIcon = () => {
        switch (props.level) {
            case "error": {
                return (
                    <ErrorIcon
                        fontSize={props.size}
                        className={props.className}
                    />
                );
            }

            case "info": {
                return (
                    <InfoNotificationIcon
                        fontSize={props.size}
                        className={props.className}
                    />
                );
            }

            case "success": {
                return (
                    <SuccessIcon
                        fontSize={props.size}
                        className={props.className}
                    />
                );
            }

            case "warning": {
                return (
                    <WarningIcon
                        fontSize={props.size}
                        className={props.className}
                    />
                );
            }
            case "custom": {
                return renderCustomIcon();
            }
        }
        return null;
    };

    return <>{getIcon()}</>;
};
